import React, { useMemo, useState } from 'react';

import DonationOptionGrid, {
  DonationOptionGridProps,
} from 'components/DonationOptionGrid/DonationOptionGrid';
import DonationOptionGridFilter from 'components/DonationOptionGridFilter/DonationOptionGridFilter';
import DonationCampaignTypes from 'models/donationCampaignTypes';
import { IDonationOption } from 'models/donationOption';
import { DonationOptionValues } from 'models/donationOptionValues';

type IProps = DonationOptionGridProps & DonationOptionValues;

const DonationOptionGridCommerce: React.FC<IProps> = ({
  donationCampaignOptions,
  donationCampaignSlug,
  underValues = [5, 10, 30, 100],
  overValues = [100],
  imageClassName,
}) => {
  const [selectedFilter, setSelectedFilter] = useState<{
    label: string;
    value: (donationOption: IDonationOption) => boolean;
  }>();
  const filteredDonationCampaignOptions = useMemo(
    () =>
      selectedFilter
        ? donationCampaignOptions.filter(selectedFilter.value)
        : donationCampaignOptions,
    [donationCampaignOptions, selectedFilter],
  );

  const showCampaignFilter = useMemo(() => {
    return (
      donationCampaignOptions.length > 4 &&
      donationCampaignSlug === 'gift-giving'
    );
  }, [donationCampaignOptions.length, donationCampaignSlug]);

  return (
    <div>
      {showCampaignFilter && (
        <DonationOptionGridFilter
          className="mb-5"
          onChange={filter => setSelectedFilter(filter)}
          value={selectedFilter}
          underValues={underValues}
          overValues={overValues}
          isGift={
            donationCampaignOptions[0].donation_campaign?.donation_campaign_type
              ?.name === DonationCampaignTypes.ProductList
          }
        />
      )}
      <DonationOptionGrid
        donationCampaignSlug={donationCampaignSlug}
        donationCampaignOptions={filteredDonationCampaignOptions}
        imageClassName={imageClassName}
      />
    </div>
  );
};

export default DonationOptionGridCommerce;
